export const formatErrorMessage = (error: any, fallback = 'There was a problem contacting the server.') => {
  if (!error.response) return fallback;
  const { response } = error;
  const errorType = String(response.status).charAt(0);
  let serverErrorMessage;
  if (errorType === '4' && response.data) {
    serverErrorMessage = response.data.errorDescription;
  }

  if (serverErrorMessage == null || serverErrorMessage.trim() === '') {
    serverErrorMessage = 'Oops... something went wrong.';
  }

  return serverErrorMessage;
};
